import { Block } from 'baseui/block';
import { ISP_Puffer } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { ValueDisplay } from '../../components/ValueDisplay'
import { themedUseStyletron } from '../../../theme/customTheme'
import { GraphicPuffer, IconPuffer } from './IconPuffer';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useMemo } from 'react';
import { schema } from '../../Devices/ElectricHeatingElement/types'
import { SmallPanel } from '../../Devices/ElectricHeatingElement/SmallPanel'
import { IAutomationObject } from '../../types';


export function OverviewPanel(props: ISP_Puffer) {
    const [css, theme] = themedUseStyletron();
    const { children } = useGetObjectsChildren(props.resourceGroupId, props.id)


    const { temperature, temperature1, temperature2, temperature3, temperature4, temperature5, temperature6, eheater } = useMemo(() => {
        const temperature = children?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor");
        const temperature1 = children?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature1Sensor");
        const temperature2 = children?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature2Sensor");
        const temperature3 = children?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature3Sensor");
        const temperature4 = children?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature4Sensor");
        const temperature5 = children?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature5Sensor");
        const temperature6 = children?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.Temperature6Sensor");
        const eheater = children?.find((v: any) => v.schema === schema);
        return { temperature, temperature1, temperature2, temperature3, temperature4, temperature5, temperature6, eheater }
    }, [children]);

    const temperaturel = useMemo(() => children?.filter((v: IAutomationObject) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor"), [children]);

    return (
        <OverviewPanelWrapper includeAlarmsFromChildren {...props} icon={<IconPuffer color={theme.colors.backgroundPrimary}></IconPuffer>}>
            <div className={css({ position: 'relative' })}>
                <GraphicPuffer height={'200px'} width={'200px'}>
                </GraphicPuffer>
                
                <div className={css({ position: 'absolute', bottom: '-120px', transform: 'rotate(90deg)',   left: '-60px', width: '200px', height: '200px'  })} >
                    {eheater && <SmallPanel {...eheater}></SmallPanel>}
                </div>
                <Block className={css({ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' })} display='flex' justifyContent={'center'}>
                    <Block display='flex' flexDirection='column' alignItems='center' justifyContent='center' gridGap='25px'>
                        <Block display='flex' flexDirection='column' alignItems='center' justifyContent='center' gridGap='20px'>

                            {!temperature1 && temperaturel && temperaturel?.map((item: any, index: number) => (
                                                 <ValueDisplay small {...item}></ValueDisplay>
                                        ))}
                            {temperature1 &&
                                <ValueDisplay  {...temperature1}></ValueDisplay>
                            }
                            {temperature2 &&
                                <ValueDisplay mini {...temperature2}></ValueDisplay>
                            }
                            {temperature3 &&
                                <ValueDisplay mini {...temperature3}></ValueDisplay>
                            }
                            {temperature4 &&
                                <ValueDisplay mini {...temperature4}></ValueDisplay>
                            }
                            {temperature5 &&
                                <ValueDisplay mini {...temperature5}></ValueDisplay>
                            }
                            {temperature6 &&
                                <ValueDisplay mini {...temperature6}></ValueDisplay>
                            }

                        </Block>
                    </Block>
                </Block>

            </div>
        </OverviewPanelWrapper >
    );
}